export interface CultureTypeCardProps {
  imageUrl: string | undefined;
  name: string;
  label: string;
}

export function CultureTypeCard({imageUrl, name, label}: CultureTypeCardProps) {
  return (
    <div className='company-matching__card'>
      <div className='company-matching__card-inner'>
        {imageUrl && (
          <div className='company-matching__card-image-wrap'>
            <img src={imageUrl} alt='' className='company-matching__card-image' />
          </div>
        )}
        <span className='company-matching__card-label'>{label}</span>
        <span className='company-matching__card-name'>{name}</span>
      </div>
    </div>
  );
}
